import {useSortable} from "@dnd-kit/sortable";
import {CSS} from "@dnd-kit/utilities";
import type React from "react";
import type {FC} from "react";

type Props = {
    id: string;
    dragable?: boolean;
    children: React.ReactNode;
    className?: string;
};

const SortableItem: FC<Props> = ({id, className, children}: Props) => {
    const {attributes, listeners, setNodeRef, transform, transition} = useSortable({
        id
    });
    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    };

    return (
        <div className={className} style={style} {...attributes} {...listeners} ref={setNodeRef}>
            {children}
        </div>
    );
};

export default SortableItem;
